import { BSWDesignSystemError } from '../../../utils/DesignSystemError';

export class ButtonInputValidationError extends BSWDesignSystemError {
  constructor(message: string) {
    super(message);
    this.name = 'ButtonInputValidationError';
  }
}
